<template>
    <div class="container">
        <div>
            <h1>Trinity Chapel&rsquo;s seat reservation</h1>
            <p>We can&rsquo;t wait to welcome you back and have been doing all we can to prepare the building to be COVID-19 secure. </p>

            <a v-on:click="startHere()" class="btn btn-primary href-btn">Reserve your seat</a>
        </div>
    </div>
</template>

<script>
    export default {
        name:"Welcome",
        methods: {
            startHere() {
               this.$router.push({ path: "/" }); 
            }
        },
    }
</script>

<style scoped>

</style>